import { JSX, useEffect, useRef } from "react";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { Dispatch } from "redux";
import { format } from "date-fns";
import { handleResendChangeEmail } from "../utils/handleResendChangeEmail";
import { handleCancelEmailChange } from "../utils/handleCancelEmailChange";
import { Notice } from "@hatch-digital-nl/abs-storybook/legacy";

interface PendingEmailChangeNoticeProps {
    selectedEmployee: EmployeeInterface;
    dispatch: Dispatch;
    resendChangeEmail: (params: { id: number }) => {
        unwrap: () => Promise<unknown>;
    };
    cancelChangeEmail: (params: { id: number }) => {
        unwrap: () => Promise<unknown>;
    };
    refetchEmployeeMe: () => Promise<unknown>;
}

export const PendingEmailChangeNoticeComponent = ({
    selectedEmployee,
    dispatch,
    resendChangeEmail,
    cancelChangeEmail,
    refetchEmployeeMe,
}: PendingEmailChangeNoticeProps): JSX.Element => {
    const noticeRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Define the event handler functions
        const handleResendClick = (): void => {
            handleResendChangeEmail({
                selectedEmployee,
                dispatch,
                resendChangeEmail,
                refetchEmployeeMe,
            });
        };

        const handleCancelClick = (): void => {
            handleCancelEmailChange({
                selectedEmployee,
                dispatch,
                cancelChangeEmail,
                refetchEmployeeMe,
            });
        };

        // Add event listeners after the component is rendered
        const resendButton =
            noticeRef.current?.querySelector(".js-resend-email");
        const cancelButton =
            noticeRef.current?.querySelector(".js-cancel-email");

        if (resendButton) {
            resendButton.addEventListener("click", handleResendClick);
        }

        if (cancelButton) {
            cancelButton.addEventListener("click", handleCancelClick);
        }

        // Clean up event listeners when the component unmounts
        return () => {
            if (resendButton) {
                resendButton.removeEventListener("click", handleResendClick);
            }

            if (cancelButton) {
                cancelButton.removeEventListener("click", handleCancelClick);
            }
        };
    }, [
        selectedEmployee,
        dispatch,
        resendChangeEmail,
        cancelChangeEmail,
        refetchEmployeeMe,
    ]);

    const formattedDate = selectedEmployee?.pending_email_change?.created_at
        ? format(
              new Date(selectedEmployee.pending_email_change.created_at),
              "dd-MM-yyyy",
          )
        : "";

    return (
        <div className={"c-create-employee-modal__form__row"} ref={noticeRef}>
            <Notice
                htmlContent={`<p>Je hebt op <b>${formattedDate}</b> een verzoek ingediend om het privé e-mailadres te wijzigen naar <b>${selectedEmployee?.pending_email_change?.new_email}.</b><br /> Deze e-mail is gestuurd naar <b>${selectedEmployee?.pending_email_change?.old_email}.</b> Controleer voor de zekerheid je spamfolder.<br /><u class="js-resend-email">Verificatie e-mail opnieuw sturen</u> of wil je de wijziging <u class="js-cancel-email">annuleren</u></p>`}
            />
        </div>
    );
};
